<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex align-items-center">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm brand-mark">
            <img src="assets/images/logo.svg" alt="" height="18">
          </span>
          <span class="logo-lg d-flex align-items-center">
            <span class="brand-mark me-2">
              <img src="assets/images/logo.svg" alt="" height="18">
            </span>
            <span class="brand-wordmark"><span class="brand-wordmark__link">Link</span><span class="brand-wordmark__exchange">Exchange</span></span>
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm brand-mark">
            <img src="assets/images/logo-light.svg" alt="" height="18">
          </span>
          <span class="logo-lg d-flex align-items-center">
            <span class="brand-mark me-2">
              <img src="assets/images/logo-light.svg" alt="" height="18">
            </span>
            <span class="brand-wordmark brand-wordmark--on-dark"><span class="brand-wordmark__link">Link</span><span class="brand-wordmark__exchange">Exchange</span></span>
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 d-lg-none header-item" (click)="toggleMenubar()">
        <i class="fa fa-fw fa-bars"></i>
      </button>
    </div>

    <!-- NAV — same row as the logo on desktop, drops to a panel below on mobile -->
    <div class="topnav flex-grow-1">
    <ul class="navbar-nav collapse" id="topnav-menu-content">
      <ng-container *ngFor="let item of menuItems">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle arrow-none text-color-menu pill-tab" *ngIf="!item.subItems" href="javascript: void(0);"
            id="topnav-components" [routerLink]="item.link" routerLinkActive="active" role="button">
            {{ item.label | translate }} <div class="arrow-down"
              *ngIf="hasItems(item)"></div>
          </a>

          <a *ngIf="item.subItems" class="nav-link dropdown-toggle arrow-none text-color-menu pill-tab"
            href="javascript: void(0);" id="topnav-components" role="button" (click)="onMenuClick($event)">
            {{item.label| translate }}
            <div class="arrow-down"></div>
          </a>

          <div class="dropdown-menu" [ngClass]="{'dropdown-mega-menu-xl px-2':  item.subItems.length > 11}" aria-labelledby="topnav-dashboard" *ngIf="hasItems(item)">
            <ng-template ngFor let-i="index" let-subitem [ngForOf]="item.subItems">
              <a *ngIf="item.subItems.length < 11 && !hasItems(subitem)" class="col dropdown-item side-nav-link-ref"
              [routerLink]="subitem.link"
              routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
               {{subitem.label | translate }}
          </a>
          <div *ngIf="item.subItems.length > 11">
              <div *ngIf="i % 3 == 0" class="row">
                  <div class="col-lg-4"><a class="dropdown-item side-nav-link-ref" routerLinkActive="active" [routerLink]="subitem.link">{{item.subItems[i].label | translate}}</a></div>
                  <div class="col-lg-4"><a class="dropdown-item side-nav-link-ref" routerLinkActive="active" [routerLink]="item.subItems[i + 1]?.link">{{item.subItems[i + 1]?.label | translate}}</a></div>
                  <div class="col-lg-4"><a class="dropdown-item side-nav-link-ref" routerLinkActive="active" [routerLink]="item.subItems[i + 2]?.link">{{item.subItems[i + 2]?.label | translate}}</a></div>
              </div>
          </div>

            <div class="dropdown" *ngIf="hasItems(subitem)">
              <a class="dropdown-item dropdown-toggle" href="javascript: void(0);"
                (click)="onMenuClick($event)">{{ subitem.label | translate }}
                <div class="arrow-down"></div>
              </a>
              <div class="dropdown-menu">
                <ng-template ngFor let-subSubitem [ngForOf]="subitem.subItems">
                  <a class="dropdown-item side-nav-link-ref" *ngIf="!hasItems(subSubitem)"
                    href="javascript: void(0);" [routerLink]="subSubitem.link"
                    routerLinkActive="active">{{ subSubitem.label | translate }}</a>
                  <div class="dropdown" *ngIf="hasItems(subSubitem)">

                    <a class="dropdown-item dropdown-toggle" href="javascript: void(0);"
                      (click)="onMenuClick($event)">{{ subSubitem.label | translate }}
                      <div class="arrow-down"></div>
                    </a>
                    <div class="dropdown-menu">
                      <ng-template ngFor let-subSubSubitem [ngForOf]="subSubitem.subItems">
                        <a class="dropdown-item side-nav-link-ref" href="javascript: void(0);"
                          [routerLink]="subSubSubitem.link"
                          routerLinkActive="active">{{ subSubSubitem.label | translate }}</a>
                      </ng-template>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </ng-template>
         </div>
        </li>
      </ng-container>
    </ul>
    </div>

    <div class="d-flex align-items-center" *ngIf="admin">
      <h2 class="font-size-16 mb-0 me-3" *ngIf="!(super)">Administrator</h2>
      <h2 class="font-size-16 mb-0 me-3" *ngIf="super">Super Administrator</h2>
    </div>

    <div class="d-flex align-items-center">
      <div *ngIf="balance != null" class="dropdown d-flex align-items-center ms-1">
        <button type="button" class="btn wallet-pill" (click)="routeRecharge()">
          <span class="wallet-pill__dot"></span>
          <h6 class="mb-0 fw-600">USD ${{balance}}</h6>
        </button>
      </div>

      <div class="dropdown d-inline-block account-menu" dropdown>
        <button type="button" class="btn header-item" dropdownToggle id="page-header-user-dropdown">
          <img *ngIf="profile_image && profile_image !== 'assets/images/users/account.webp'"
            class="rounded-circle header-profile-user" src={{profile_image}} onerror="this.onerror=null; this.src='assets/images/users/account.webp'">
          <span *ngIf="!profile_image || profile_image === 'assets/images/users/account.webp'" class="avatar-meridian avatar-meridian--36 avatar-meridian--advertiser header-profile-user">{{getInitials()}}</span>
          <span class="d-none d-xl-inline-block ms-1">{{profile_name}}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end account-menu__panel" *dropdownMenu>
          <a class="dropdown-item" routerLink="/account/profile"><i class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.PROFILE' | translate}}</a>
          <a class="dropdown-item enablePointer" (click)="routeRecharge()"><i class="bx bx-wallet font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.MY_WALLET' | translate}}</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item account-menu__logout" href="javascript: void(0);" (click)="logout()">
            <i class="bx bx-power-off font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.LOGOUT' | translate}}</a>
        </div>
      </div>

      <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item noti-icon right-bar-toggle" (click)="toggleMode()" title="Toggle dark mode">
          <i class="bx bxs-moon"></i>
        </button>
      </div>
    </div>
  </div>
</header>
